module.exports = __webpack_public_path__ + "82fab19c4b0e37c64992aa22007d69e4.png";